import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function CriticalIllness({ classes, expanded, criticalIllness, handleChange }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('criticalIllness')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('criticalIllness') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Critical Illness</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        criticalIllness.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    } 

                    <div style={classes.row}>
                        <Text small bold margin="20px 0px 10px 0px">
                            {criticalIllness.flatAmount > 0 ? `You have $${ helpers.formatNumber(criticalIllness.flatAmount) } available for Critical Illness coverage.` : null }
                        </Text>
                    </div>

                    <Text small margin="5px 0px 0px 0px">{ criticalIllness.maxEvidence > 0 ? `$${ helpers.formatNumber(criticalIllness.maxEvidence) } Maximum with evidence of insurability.` : null }</Text>
                    <Text small margin="5px 0px 0px 0px">{ criticalIllness.maxNoEvidence > 0 ? `$${ helpers.formatNumber(criticalIllness.maxNoEvidence) } Maximum with non-evidence of insurability.` : null }</Text>
                    <Text small margin="5px 0px 0px 0px">{ `Coverage reduces by ${ criticalIllness.reducesBy }% at age ${ criticalIllness.reducesAtAge }, provided the member is still actively working.` }</Text>
                    <Text small margin="5px 0px 10px 0px">{Boolean(criticalIllness.includeSecondReduction) && `Coverage further reduces by ${ criticalIllness.furtherReducesBy }% at age ${ criticalIllness.furtherReductionAge }.`}</Text>
                    <Text small margin="5px 0px 0px 0px">{ `Terminates at age ${ criticalIllness.terminationAge } or date of participants retirement if earlier.` }</Text>

                </AccordionDetails>
            </Accordion>
        </div>
    );
}